import * as yup from "yup";

const logValidationError = (message) => {
  console.log(`Validation failed: ${message}`);
  return false; // Returning `false` means the validation failed
};

const schemaGenerator = (variant) => {
  let requiredObj = {
    labReport: yup
      .mixed()
      .required("Please provide a file for the Lab Report")
      .test("required", "Please provide a file for the Lab Report", (value) => {
        return value !== undefined && value !== null && value !== "";
      }),
    labReportMetadata: yup
      .mixed()
      .required("Please provide a file for the Lab Report Metadata")
      .test(
        "required",
        "Please provide a file for the Lab Report Metadata",
        (value) => {
          return value !== undefined && value !== null && value !== "";
        }
      ),
    overallSafetyCompliant: yup
      .string()
      .required("Please select option for Overall Safety Compliant")
      .matches(/^(?!\s+$).+/, "Please select option for the above field")
      .label("Overall Safety Compliant")
      .test(
        "log-error",
        "Please provide value for Overall Safety Compliant",
        function (value) {
          if (!value || /^\s*$/.test(value)) {
            logValidationError(
              "Overall Safety Compliant is invalid or missing"
            );
            return false;
          }
          return true;
        }
      ),
    overallQualityCompliant: yup
      .string()
      .required("Please select option for Overall Quality Compliant")
      .matches(/^(?!\s+$).+/, "Please select option for the above field")
      .label("Overall Quality Compliant")
      .test(
        "log-error",
        "Please provide value for Overall Quality Compliant",
        function (value) {
          if (!value || /^\s*$/.test(value)) {
            logValidationError(
              "Overall Quality Compliant is invalid or missing"
            );
            return false;
          }
          return true;
        }
      ),
    overallSampleClassification: yup
      .string()
      .required("Please select option for Overall Sample Classification")
      .matches(/^(?!\s+$).+/, "Please select option for the above field")
      .label("Overall Sample Classification")
      .test(
        "log-error",
        "Please provide value for Overall Sample Classification",
        function (value) {
          if (!value || /^\s*$/.test(value)) {
            logValidationError(
              "Overall Sample Classification is invalid or missing"
            );
            return false;
          }
          return true;
        }
      ),
  };

  if (variant !== "Loose") {
    requiredObj.overallLabellingCompliant = yup
      .string()
      .required("Please select option for Overall Labelling Compliant")
      .matches(/^(?!\s+$).+/, "Please select option for the above field")
      .label("Overall Labelling Compliant")
      .test(
        "log-error",
        "Please provide value for Overall Labelling Compliant",
        function (value) {
          if (!value || /^\s*$/.test(value)) {
            logValidationError(
              "Overall Labelling Compliant is invalid or missing"
            );
            return false;
          }
          return true;
        }
      );
  }
  // data.forEach((obj) => {
  //   requiredObj[`${obj.key}`] = yup
  //     .number()
  //     .required(`${obj.parameter} is a required field`)
  //     .typeError(`Only numbers are allowed for ${obj.parameter}`)
  //     .test(
  //       "no-spaces",
  //       `Spaces are not allowed in ${obj.parameter}`,
  //       function (value) {
  //         if (!value) {
  //           logValidationError(
  //             `${obj.parameter} is invalid or missing`
  //           );
  //           return false;
  //         }
  //         return true;
  //       }
  //     )
  //     .transform((value, originalValue) => {
  //       if (originalValue === '') {
  //         return undefined;
  //       }

  //       if (typeof originalValue === 'string' && originalValue.includes(' ')) {
  //         return NaN;
  //       }

  //       const num = Number(originalValue);
  //       return isNaN(num) ? NaN : num;
  //     })
  //     .min(
  //       obj.minOperationalValue,
  //       `Value should be atleast ${obj.minOperationalValue}`
  //     )
  //     .max(
  //       obj.maxOperationalValue,
  //       `Value should not exceed ${obj.maxOperationalValue}`
  //     );
  // });
  // //console.log(requiredObj);

  const schema = yup.object().shape(requiredObj);
  return schema;
};

export default schemaGenerator;
